export const SUPPORTED_SERVICES = ["youtube"]
export const ERROR_MESSAGES = {
  INVALID_FORMAT: "Invalid video URL format",
  UNSUPPORTED_SERVICE: (service) => `Unsupported video service: ${service}`
}
export const CSS_CLASSES = {
  INVALID: "invalid"
}
export const YOUTUBE_BASE_URL = "https://www.youtube.com/watch?v="